import React from 'react'
import MusicVideoGrid from './MusicVideoGrid'

const Watch = () => {
  return (
    <>
      <MusicVideoGrid />
    </>
  )
}

export default Watch
